<template>
  <div class="submit-query-container">
    <div class="heading yt-grad">
      {{leadFormMessage.header_message}}
    </div>
    <div class="phone-number leadform-phone-number" v-if="leadFormMessage.showCallCenterNumber">
      <i class="icon-phone-call"></i> {{leadFormMessage.leadform_callcenterNumber}}
    </div>
    <div class="leadform-header-suffix" v-if="!leadFormMessage.showCallCenterNumber">
      {{leadFormMessage.lead_message}}
    </div>
    <transition name="submit-error">
      <p v-if="showSubmitError" class="form-submit-error">Oops! Your lead could not be submitted </p>
    </transition>
    <div class="form-container leadform-form-container">
      <form autocomplete="off">
        <div class="form-row">
          <div class="form-column">
            <div class="input-group">
              <input id="mpLeadCustomerName" type="text" class="form-field" v-model="submitFormData.customerName" @input="$v.submitFormData.customerName.$touch()" :class="{'has-value': submitFormData.customerName}" :disabled="user && user.customerName" />
              <label for="mpLeadCustomerName">Your Name</label>
              <p class="field-error" v-if="$v.submitFormData.customerName.$error">Please enter valid name.</p>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-column">
            <div class="input-group">
              <input id="mpLeadCustomerEmail" type="text" class="form-field" v-model="submitFormData.customerEmailId" @input="$v.submitFormData.customerEmailId.$touch()" :class="{'has-value': submitFormData.customerEmailId}" :disabled="user && user.customerEmailId" />
              <label for="mpLeadCustomerEmail">Your email ID</label>
              <p class="field-error" v-if="$v.submitFormData.customerEmailId.$error">Please enter valid email.</p>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-column">
            <div class="form-group">
              <div class="input-group">
                <span id="countryCodeText">{{submitFormData.customerIsdCode ? '+' + submitFormData.customerIsdCode : ''}}
                  <i class="icon icon-down-open"></i>
                  <select ref="countryCode" id="countryCode" v-model="submitFormData.customerIsdCode" :disabled="user && user.customerISDCode">
                    <!-- <option selected name="title">+91</option> -->
                    <option v-for="isdCode in ISDCodes" :value="isdCode.countryCode" :key="isdCode.slNo">{{isdCode.countryName}} (+{{isdCode.countryCode}})</option>
                  </select>
                </span>

                <input type="text" class="form-field has-value mobile-number" v-model="submitFormData.customerMobile" @input="$v.submitFormData.customerMobile.$touch()" id="mobileNo" :disabled="user && user.customerPhoneNumber" />
                <label for="mobileNo">Mobile Number</label>

                <p class="field-error mobile-error" v-if="$v.submitFormData.customerMobile.$error">Please enter valid phone number.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-column">
            <div class="form-group">
              <div class="input-group">
                <select id="customerOrigin" class="form-field pad-right-30" v-model="submitFormData.origin" @input="$v.submitFormData.origin.$touch()" :class="{'has-value': submitFormData.origin}">
                  <option name="city" v-for="city in citiesList" :key="city" v-text="city"></option>
                </select>
                <label for="customerOrigin">Origin City</label>

                <p class="field-error" v-if="$v.submitFormData.origin.$error">Please Enter a valid origin city</p>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-column">
            <div class="form-group">
              <div class="input-group">
                <input id="departureDate" readonly v-model="submitFormData.travelStartDate" type="text" class="form-field" :class="{'has-value': submitFormData.travelStartDate}" />
                <label for="departureDate">When do you want to go?</label>
                <span class="icon-calendar-empty"></span>

                <p class="field-error" v-if="$v.submitFormData.travelStartDate.$error">Please enter valid date.</p>
              </div>

            </div>
          </div>

        </div>
        <!-- <div class="form-row" v-if="isMPForm">
          <div class="form-column">
            <div class="form-group">
              <div class="input-group">
                <select id="mpLeadCustomerPlanning" class="form-field pad-right-30" v-model="submitFormData.planningStage" :class="{'has-value': submitFormData.planningStage}">
                  <option name="planningStage" v-for="stage in planningStages" :key="stage.key" :value="stage.key" v-text="stage.value"></option>
                </select>
                <label for="mpLeadCustomerPlanning">Planning Stage</label>
              </div>
            </div>
          </div>
        </div> -->

        <div class="form-row no-of-travellers">
          <p class="travellers">No. of Travellers</p>
          <div class="form-group form-column">
            <div class="input-group">
              <select id="adultCount" class="form-field has-value" v-model="submitFormData.paxWiseCount.ADULT">
                <option name="adult" v-for="i in (1, 20)" :key="i" v-bind:value="i">{{i}}</option>
              </select>
              <label for="adultCount">Adult</label>

            </div>
          </div>

          <div class="form-group form-column">
            <div class="input-group">
              <select id="childCount" class="form-field has-value" v-model="submitFormData.paxWiseCount.CHILD">
                <option value="0">0</option>
                <option v-for="i in (1, 20)" :key="i" v-bind:value="i">{{i}}</option>
              </select>
              <label for="childCount">Child 2-12 YRS</label>
            </div>
          </div>

          <div class="form-group form-column">
            <div class="input-group">
              <select id="infantCount" class="form-field has-value" v-model="submitFormData.paxWiseCount.INFANT">
                <option value="0">0</option>
                <option v-for="i in (1, 20)" :key="i" v-bind:value="i">{{i}}</option>
              </select>
              <label for="infantCount">Infant 0-2 YRS</label>
            </div>
          </div>

        </div>

        <div class="note">
          {{leadFormMessage.consent_message}}
          <a>
            <div class="tooltip-container">
              <a class="show-tooltip">
                Know More
                <div class="tooltip-box tooltip-highlight tooltip-leadform  down-arrow">
                  <p class="info-know-more">
                  	{{leadFormMessage.tooltip_message}}
                  </p>
                </div>
              </a>
            </div>
          </a>
        </div>

        <button type="button" class="btn btn-primary" @click="submitForm" :class="{'invalidForm': $v.submitFormData.$invalid}" :disabled="$v.submitFormData.$invalid">Submit Query</button>
      </form>

    </div>
    <div class="suggestions-yt">
      <p class="heading">Why Travel with us ?</p>

      <ul>
        <li class="col-3">
          <i class="icon icon-best-price"></i>
          <p class="title"> Best Price</p>
          <p class="subtext">A marketplace of suppliers </p>
        </li>
        <li class="col-3">
          <i class="icon icon-customization"></i>
          <p class="title"> Customization</p>
          <p class="subtext">Real time
            <br>end to end customization </p>
        </li>
        <li class="col-3">
          <i class="icon icon-booking-ease"></i>
          <p class="title"> Booking With Ease</p>
          <p class="subtext">Stay in touch with our expert on live chat </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/* global globalConfig loggedUserDetails chatMasterdata leadFormDepCities sso angular lrsDetails yt_adobe */

import { email, required, minLength, maxLength } from 'vuelidate/lib/validators'
import axios from 'axios'
import name from '../../common/nameValidator'
import mobileNumber from '../../common/mobileNumberValidator'
import calendar from '../../common/calendar'
import ISDData from '../../common/ISDService'
import URLs from '../../common/URLStore'
import addDigitalDataObject from '../../common/tracking'

export default {
  mixins: [ISDData],
  props: ['user', 'isMPForm', 'leadFormMessage', 'destination', 'showSubmitError', 'preFillData'],
  data: function() {
    let dataProps = {
      citiesList: [],
      mobileMinLength: 10,
      mobileMaxLength: 10,
      submitFormData: {
        destination: '',
        travelStartDate: '',
        customerName: '',
        customerEmailId: '',
        customerMobile: '',
        customerIsdCode: '91',
        leadReceivedFrom: this.isMPForm ? 'chat_lead_srp_docked' : 'PopupBox:DOMSRPDestinationPage',
        product: (window.isFranchisee)?'HOLIDAYS_FRANCHISE':'HOLIDAYS',
        leadType: 'DIRECT',
        pageType: 'SRP',
        platform: document.documentElement.clientWidth <= 768 ? 'WAP' : 'DESKTOP',
        pageUrl: window.location.href,
        // eslint-disable-next-line
        notifyYatra: (window.isIE) ? true : false
      },
      loggedUserDetails: {},
      planningStages: [],
      hasDateValue: false
    }
    dataProps.submitFormData.origin = ''
    dataProps.submitFormData.paxWiseCount = {
      ADULT: 1,
      CHILD: 0,
      INFANT: 0
    }
    if (this.preFillData) {
      dataProps.submitFormData = this.preFillData
    }
    return dataProps
  },
  computed: {
    ISDCodes: function() {
      return this.getISDCodes()
    }
  },
  watch: {
    'submitFormData.customerIsdCode': function(newValue) {
      if (newValue == '91') {
        this.mobileMinLength = 10
        this.mobileMaxLength = 10
      } else {
        this.mobileMinLength = 4
        this.mobileMaxLength = 17
      }
    },
    destination: function(newValue) {
      this.submitFormData.destination = newValue
    },
    'submitFormData.customerMobile': function(newValue) {
      if (newValue && Number.isNaN(Number(newValue))) {
        this.submitFormData.customerMobile = this.submitFormData.customerMobile.substring(0, this.submitFormData.customerMobile.length - 1)
      }
    }
  },
  methods: {
    submitForm: function() {
      // Adobe tracking on click of submit query submit_tracking#3
      if (typeof yt_adobe !== 'undefined' && typeof yt_adobe.track == 'function') {
        var obj = addDigitalDataObject()
        var request = {
          requestInfo: {
            emailID: this.submitFormData.customerEmailId ? this.submitFormData.customerEmailId : '',
            mobileNumber: this.submitFormData.customerMobile ? this.submitFormData.customerMobile : '',
            city: this.submitFormData.origin ? this.submitFormData.origin : ''
          }
        }
        var package1 = {
          packageInfo: {
            packageComponent: 'submit Query'
          }
        }
        obj.request = request
        obj['package'] = package1
        yt_adobe.track('contact-expert-request-initiated', obj)
      }

      var vm = this
      function submitLeadForm(formData) {
        vm.showSubmitError = false
        vm.$emit('showLoader')
        return axios
          .post(URLs.submitQuery, formData, {
            headers: {
              Authorization: lrsDetails.lrsApiKey,
              'com.yatra.tenant.header.tenantId': lrsDetails.lrstenantId
            }
          })
          .then(resp => {
            vm.$emit('hideLoader')
            let templateStrings = resp.data.messages
            templateStrings.forEach((obj, index, source) => {
              if(obj.messageParams) {
                let len = obj.messageParams.length
                if(len>0) {
                  for(let i=0; i<len; i++) {
                    if(obj.message.indexOf('#'+obj.messageParams[i].name.trim()) >= 0) {
                      let replaceValue = ''
                      if(obj.messageParams[i].elem === "strong") 
                        replaceValue = '<b>'+obj.messageParams[i].value+'</b>'
                      else
                        replaceValue = obj.messageParams[i].value
                      source[index].message = source[index].message.replace('#'+obj.messageParams[i].name.trim(),replaceValue)
                    }
                  }
                }
              }              
              source[index] = {message: obj.message, type: obj.elem}
            });
            let dynamicProps = {
              leadId: resp.data.leadId,
              user: { customerName: vm.submitFormData.customerName, isdCode: vm.submitFormData.customerIsdCode },
              destination: vm.destination,
              companyName: resp.data.responseParameters.companyName,
              isMPLead: globalConfig.isMarketplaceOnlyPackages,
              leadFormMessage: vm.leadFormMessage,
              tollFreeNumber: vm.tollFreeNumber,
              leadData: formData,
              templateString: templateStrings
            }
            let view = resp.data.showSecondStep ? 'step2' : 'thankYou'
            let errorTemplate = [{ "message": "Oops!", "elem": "strong" }, { "message": "Your lead could not be submitted, Please try again.", "elem": "span" }]
            if (dynamicProps.templateString.length === 0) {
              dynamicProps.templateString = errorTemplate
            }
            // vm.dynamicProps.user = loggedUserDetails
            // open chat
            let leadResponsesList = resp.data.leadInteractionResponseList
            for (var x = 0; x < leadResponsesList.length; x++) {
              if (leadResponsesList[x].service == 'chat') {
                if (leadResponsesList[x].interactionId != '') {
                  dynamicProps.chatId = leadResponsesList[x].interactionId
                  if (typeof angular != 'undefined' && sso.isUserLoggedIn()) {
                    var scopeObj = angular.element(document.getElementById('chat-overlay')).scope()
                    if (scopeObj) {
                      scopeObj.selectContactByChatId(leadResponsesList[x].interactionId)
                      // Adobe tracking on load of chat submit_tracking#11
                      if (typeof yt_adobe !== 'undefined' && typeof yt_adobe.track == 'function') {
                        var obj = addDigitalDataObject()
                        obj.page.pageInfo.popName = 'lead form chat success'
                        var request = {
                          requestInfo: {
                            emailID: vm.submitFormData && vm.submitFormData.customerEmailId ? vm.submitFormData.customerEmailId : '',
                            mobileNumber: vm.submitFormData && vm.submitFormData.customerMobile ? vm.submitFormData.customerMobile : '',
                            city: vm.submitFormData.origin ? vm.submitFormData.origin : '',
                            leadID: leadResponsesList[x].interactionId ? leadResponsesList[x].interactionId : ''
                          }
                        }
                        var package1 = {
                          packageInfo: {
                            packageComponent: 'submit Query chat success'
                          }
                        }
                        obj.request = request
                        obj['package'] = package1
                        yt_adobe.track('lead-form-chat', obj)
                      }
                    }
                  }
                }
              }
            }

            let viewObj = { props: dynamicProps, viewName: view }
            // vm.$emit('changeView', viewObj)
            viewObj.status = 'success'

            // Adobe tracking On load of successful submission page of Send Query(2nd pop up) submit_tracking#7
            if (typeof yt_adobe !== 'undefined' && typeof yt_adobe.track == 'function') {
              var obj = addDigitalDataObject()
              var request = {
                requestInfo: {
                  emailID: formData.customerEmailId ? formData.customerEmailId : '',
                  mobileNumber: formData.customerMobile ? formData.customerMobile : '',
                  city: formData.origin ? formData.origin : '',
                  leadID: resp.data.leadId
                }
              }
              var package1 = {
                packageInfo: {
                  packageComponent: 'submit Query success'
                }
              }
              obj.request = request
              obj['package'] = package1
              yt_adobe.track('contact-expert-request-success', obj)
            }

            return viewObj
          })
          .catch(() => {
            vm.$emit('hideLoader')
            let dynamicProps = {
              showSubmitError: true
            }
            let usrLoggedIn = sso.isUserLoggedIn()
            dynamicProps.isMPForm = globalConfig.isMarketplaceOnlyPackages
            dynamicProps.leadFormMessage = vm.leadFormMessage
            dynamicProps.destination = vm.destination
            if (usrLoggedIn) {
              dynamicProps.user = loggedUserDetails
            }
            dynamicProps.preFillData = vm.submitFormData
            let view = 'mpLeadForm'
            let viewObj = { props: dynamicProps, viewName: view }
            return viewObj
          })

        // return reqPromise
      }
      // set destination
      this.submitFormData.destination = this.destination
      if (sso.isUserLoggedIn() && loggedUserDetails.customerPhoneNumber) {
        submitLeadForm(this.submitFormData)
          .then(resp => {
            vm.$emit('changeView', resp)
          })
          .catch(() => {
            this.showSubmitError = true
          })
      } else {
        let dynamicProps = {
          formData: this.submitFormData,
          successCallback: () => {
            return submitLeadForm(this.submitFormData)
          }
        }
        this.view = 'leadFormOTP'
        this.$emit('changeView', { props: dynamicProps, viewName: 'leadFormOTP' })
      }
    }
  },
  validations: function() {
    let requiredValidators = {
      submitFormData: {
        customerEmailId: {
          required,
          email
        },
        customerName: {
          required,
          name,
          minLength: minLength(3)
        },
        customerMobile: {
          required,
          mobileNumber,
          minLength: minLength(this.mobileMinLength),
          maxLength: maxLength(this.mobileMaxLength)
        },
        travelStartDate: {
          required
        },
        origin: {
          required
        }
      }
    }
    return requiredValidators
  },
  created: function() {
    // Adobe tracking On load of  pop up of send query submit_tracking#2
    if (typeof yt_adobe !== 'undefined' && typeof yt_adobe.track == 'function') {
      var obj = addDigitalDataObject()
      obj.page.pageInfo.popName = 'lead form'
      yt_adobe.track('popup-load', obj)
    }

    this.loggedUserDetails = loggedUserDetails
    // this.chatMasterdata = chatMasterdata

    if (chatMasterdata) {
      for (var property in chatMasterdata) {
        if (chatMasterdata.hasOwnProperty(property)) {
          this.planningStages.push({ key: property, value: chatMasterdata[property] })
        }
      }
    }

    if (!(typeof leadFormDepCities === 'undefined')) {
      this.citiesList = leadFormDepCities
    }

    if (this.user) {
      this.submitFormData.customerName = this.user.customerName
      this.submitFormData.customerEmailId = this.user.customerEmailId
      this.submitFormData.customerMobile = this.user.customerPhoneNumber
      this.submitFormData.customerIsdCode = this.user.customerISDCode || '91'
    }
  },
  mounted: function() {
    calendar.calendar.render('departureDate', null, newValue => {
      this.submitFormData.travelStartDate = newValue
    })
    document.getElementById('departureDate').value = this.preFillData ? this.preFillData.travelStartDate : ''
  }
}
</script>

<style lang="scss" scoped="true">
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}

#countryCode {
  opacity: 0;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
}

#countryCodeText {
  border-bottom: 1px solid #d9d9d9;
  height: 35px;
  width: 70px;
  float: left;
  position: relative;
  vertical-align: bottom;
  /* border-top: 1px solid #d9d9d9; */
  padding: 8px 0px;

  .icon-down-open {
    float: right;
    line-height: 18px;
  }
}

.pad-right-30 {
  padding-right: 30px;
}

#departureDateCalendar {
  width: 242px;
}

.mobile-error {
  width: 100%;
}
.icon-down-open {
  font-size: 14px;
}

.no-of-travellers {
  clear: both;
  margin-left: 0px !important;
  margin-bottom: 15px;

  .form-column {
    width: 150px !important;
  }
}

.form-submit-error {
  color: black;
  font-size: 12px;
  padding-top: 5px;
  padding: 10px;
  background: #f89595;
}

.submit-error-enter-active,
.submit-error-leave-active {
  transition: all 0.5s ease;
}

.submit-error-enter,
.submit-error-leave-to {
  height: 0px;
}

.mobile-number {
  width: 195px;
  padding-left: 15px;
}
.submit-query-container {
  .icon-calendar-empty {
    position: absolute;
    right: 0px;
    top: 10px;
    color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lead-form/mponly-lead-form.vue